import moment from "moment";
import { useEffect, useState } from "react";

export const Timer = ({
    hours,
    onTimerZero,
    withDelay = 15,
    format
}: {
    hours: number,
    onTimerZero?: () => void,
    withDelay?: number,
    format?: string
}) => {

    const [time, setTime] = useState(0)
    const [initialized, setInitialized] = useState(false)

    useEffect(() => {

        const timer = setInterval(() => {
            setTime((prevTime) => prevTime > 0 ? prevTime - 1 : 0);
        }, 1000);

        return () => clearInterval(timer);

    }, [])

    useEffect(() => {
        if (hours) {
            setTime(hours)
            setTimeout(() => {
                setInitialized(true)
            }, 1000);
        }
    }, [hours])

    useEffect(() => {
        if (time === 0 && initialized) {
            setTimeout(() => {
                onTimerZero && onTimerZero()
            }, withDelay ? withDelay * 1000 : 0);
        }
    }, [time, initialized])

    return <>{formatTime(time, format)}</>

}

const formatTime = (time: number, format?: string) => {
    const duration = moment.duration(time, 'seconds');

    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    const pad = (num: number) => String(num).padStart(2, '0');

    if (format) {
        return format
            .replaceAll("DD", pad(days))
            .replaceAll("HH", pad(hours))
            .replaceAll("MM", pad(minutes))
            .replaceAll("SS", pad(seconds))
    }

    return days > 0
        ? `${days}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`
        : `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
};